import script from "./DownloadSurveysPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadSurveysPopover.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadSurveysPopover.vue?vue&type=style&index=0&id=4623b77f&lang=scss"

const __exports__ = script;

export default __exports__